<template>
	<div class="form-group">
		<label
			:style="'color:' + template.style.surveyTextColor"
			class="title-bold"
			for="nome"
		>
			{{ questionText }}
		</label>
		<p
			:style="
				template.style.surveyBgColor
					? { color: template.style.secondColor }
					: { color: black }
			"
			class="observation"
		>
			{{ questionObs }}
		</p>
		<p class="card-subtitle mb-1">
			{{ $t('you_can_upload_files_in_the_following_formats_with_limit')}}:
		</p>
		<ul class="ml-1">
			<li v-for="(format, i) in displayFormats" :key="i" class="ml-3">
				{{ format }}
			</li>
		</ul>

		<!-- Arquivos selecionados-->
		<div
			class="q-buttonlist-selected"
			vs-align="center"
			vs-type="flex"
			vs-justify="space-around"
			v-show="qtAnwser"
		>
			<button
				:style="
					template.style.surveyBgColor
						? { color: template.style.firstColor }
						: { color: '#212529' }
				"
				class="c-checkbox-container btn-check"
			>
				<span>{{ qtAnwser.split("/").reverse()[0] }} </span>
				<input type="checkbox" checked="checked" disabled />
				<!-- disabled to not uncheck -->
				<span class="checkmark" @click="removeOption"> </span>
			</button>
		</div>

		<div class="d-flex align-items-center">
			<div class="mb-3">
				<input
					id="file"
					ref="file"
					class="file-input"
					type="file"
					:accept="fileAccept"
					@change="uploadFile"
				/>

				<vs-button icon="file_upload">
					<label class="m-0 cursor-pointer" for="file">
						{{ $t('browse')}}...
					</label>
				</vs-button>
			</div>

			<p class="mb-0 ml-3">
				{{ fileName ? fileName : $t('select_a_file') }}
			</p>
		</div>
	</div>
</template>

<script>
import axios from "axios";

export default {
	name: "SurveyUploadFile",
	props: {
		questionText: { type: String },
		questionObs: { type: String, default: '' },
		questionId: { type: Number },
		config: { type: String },
	},
	data: () => ({
		qtAnwser: "",
		processingApi: false,
		fileName: "",
	}),
	computed: {
		template() {
			return this.$store.state.template;
		},
		restrictedExtensions() {
			const c = this.config;
			if (!c || !String(c).includes("allowed_extensions_file")) {
				return null;
			}
			const segments = String(c).split(";");
			for (let s = 0; s < segments.length; s++) {
				const seg = segments[s];
				if (!seg.includes("allowed_extensions_file")) continue;
				const parts = seg.split(":");
				const idx = parts.indexOf("allowed_extensions_file");
				if (idx === -1) continue;
				const value = parts.slice(idx + 1).join(":").trim();
				if (!value) return null;
				const list = value
					.split(",")
					.map((ext) => ext.trim().toLowerCase().replace(/^\./, ""))
					.filter(Boolean);
				return list.length ? list : null;
			}
			return null;
		},
		/** Com `n:allowed_extensions_file:...` usa a lista do config; senão pdf, png, jpg. */
		effectiveExtensions() {
			if (this.restrictedExtensions && this.restrictedExtensions.length) {
				return this.restrictedExtensions;
			}
			return ["pdf", "png", "jpg"];
		},
		displayFormats() {
			return this.effectiveExtensions.map((e) => e.toUpperCase());
		},
		fileAccept() {
			return this.effectiveExtensions.map((e) => `.${e}`).join(",");
		},
	},
	created() {
		if (this.$store.getters.answerValue(this.questionId)) {
			this.qtAnwser = this.$store.getters.answerValue(this.questionId);
		}
	},
	updated() {
		this.focusInput();
	},
	methods: {
		focusInput() {
			this.$refs.fc.$el.focus();
		},
		allKeys() {
			this.$emit("AnswerChanged", this.qtAnwser, this.questionId);
		},
		clearFile() {
			this.Images = {};
			this.fileName = "";
		},
		uploadFile() {
			const input = this.$refs.file;
			const file = input.files && input.files[0];
			if (!file) return;

			const name = file.name || "";
			const dot = name.lastIndexOf(".");
			const ext = dot === -1 ? "" : name.slice(dot + 1).toLowerCase();
			if (!this.effectiveExtensions.includes(ext)) {
				this.$vs.notify({
					color: "warning",
					title: this.$t("warning"),
					text: this.$t("upload_invalid_file_extension", {
						formats: this.displayFormats.join(", "),
					}),
				});
				input.value = "";
				this.fileName = "";
				return;
			}

			this.Images = file;
			this.fileName = file.name;
			this.submitFile();
		},
		submitFile() {
			const formData = new FormData();
			formData.append("file", this.Images);
			const headers = { "Content-Type": "multipart/form-data" };
			axios
				.post(
					`https://dashapi.fanbase.com.br/api/Files/UserSurveyFile/${this.$store.state.project.ownerId}/${this.$store.state.surveyStruct.surveyId}/${this.$store.state.surveyUserId}/${this.questionId}`,
					formData,
					{ headers }
				)
				.then((res) => {
					let src;
					if (res.data.header.codigo === 1) {
						this.fileName = this.$refs.file.files[0].name
							? this.$refs.file.files[0].name.split(".")[0]
							: "Uploaded image";
						src = res.data.data ? res.data.data[0] : "Src";
						this.$vs.notify({
							color: "success",
							title: this.$t('upload_success'),
							text: this.$t('file_upload_completed'),
						});
						this.qtAnwser = src;
						this.$emit("AnswerChanged", src, this.questionId);
						this.clearFile();
					} else if (
						res.data.header.codigo === 0 &&
						res.data.header.msg.startsWith("Arquivo já existente")
					) {
						this.fileName = this.$refs.file.files[0].name
							? this.$refs.file.files[0].name.split(".")[0]
							: "Uploaded image";
						src = `https://config.fanbase.com.br/user/fanbase/${this.$store.state.project.ownerId}/files/${this.$refs.file.files[0].name}`;
						this.$vs.notify({
							color: "success",
							title: this.$t('added_successfully'),
							text: this.$t('file_found_and_registered'),
						});
						this.qtAnwser = src;
						this.$emit("AnswerChanged", src, this.questionId);
						this.clearFile();
					} else {
						this.$vs.notify({
							color: "danger",
							title: this.$t('upload_error'),
							text: `${res.data.header.msg}`,
						});
						this.$refs.file.files[0] = 0;
						this.clearFile();
					}
				});
		},
		removeOption() {
			this.qtAnwser = "";
			this.$emit("AnswerChanged", this.qtAnwser, this.questionId);
			this.clearFile();
		},
	},
	directives: {
		focus: {
			// directive definition
			inserted: function(el) {
				el.focus();
			},
		},
	},
};
</script>

<style scoped>
.title-bold {
	font-family: "OxaniumBold";
}
.c-upload >>> .con-input-upload {
	height: 100px;
}
.c-upload {
	width: auto;
}

.file-input {
	display: none;
}

.btn-check {
	border: none;
	background-color: transparent;
}

.btn-check:hover,
.btn-check:focus {
	background-color: transparent !important;
}

.btn-check:focus input ~ .checkmark {
	box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.5);
}

button.c-checkbox-container.btn-check:hover span {
	color: var(--survey-text-color) !important;
}
</style>
